import { render, staticRenderFns } from "./CreerStrategieBagage.vue?vue&type=template&id=995c7b04&scoped=true"
import script from "./CreerStrategieBagage.vue?vue&type=script&lang=js"
export * from "./CreerStrategieBagage.vue?vue&type=script&lang=js"
import style0 from "./CreerStrategieBagage.vue?vue&type=style&index=0&id=995c7b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995c7b04",
  null
  
)

export default component.exports